import { render, staticRenderFns } from "./CbList.vue?vue&type=template&id=9a547a94&"
import script from "./CbList.vue?vue&type=script&lang=js&"
export * from "./CbList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports